"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.vFacilityReadiness = exports.rpmNotificationAttributes = exports.rpmStandingCcs = exports.rpmRoutingEndpoints = exports.rpmRoutingContacts = exports.rpmCareUnits = exports.rpmFacilityRouting = exports.rpmFacilityProfiles = exports.classificationBands = exports.classificationBandSets = exports.vitalSignDefinitions = exports.sourceSystems = void 0;
// Reference and configuration — docs/rpm/effective/03-RPM-SCHEMA.md §4.2, declared in §7.4. Eleven
// tables and the readiness view: the first build's five, and the facility routing profile, the care
// units and the routing directory of CR-43. config_entity_registries is NOT here: §7.1 places it in
// rpm-audit.ts with the change trail it serves.
const pg_core_1 = require("drizzle-orm/pg-core");
const drizzle_orm_1 = require("drizzle-orm");
const schema_1 = require("./schema");
const foundation_1 = require("./foundation");
const e = __importStar(require("./rpm-enums"));
exports.sourceSystems = (0, pg_core_1.pgTable)("source_systems", {
    sourceSystemId: (0, pg_core_1.uuid)().primaryKey().defaultRandom(),
    tenantId: (0, pg_core_1.uuid)()
        .notNull()
        .references(() => foundation_1.tenants.tenantId),
    sourceSystemCode: (0, pg_core_1.text)().notNull(),
    displayName: (0, pg_core_1.text)().notNull(),
    mirrorDataSourceValue: (0, pg_core_1.varchar)({ length: 20 }), // aligns with carease.*.data_source — N2
    ingestContractRef: (0, pg_core_1.text)(),
    suppliesOxygenStatus: (0, pg_core_1.boolean)().notNull().default(false),
    validFrom: (0, pg_core_1.date)().notNull(),
    validTo: (0, pg_core_1.date)(),
    recordedAt: (0, pg_core_1.timestamp)({ withTimezone: true }).notNull().defaultNow(),
    supersededAt: (0, pg_core_1.timestamp)({ withTimezone: true }),
    createdAt: (0, pg_core_1.timestamp)({ withTimezone: true }).notNull().defaultNow(),
    createdBy: (0, pg_core_1.uuid)()
        .notNull()
        .references(() => schema_1.user.id),
    updatedAt: (0, pg_core_1.timestamp)({ withTimezone: true }).notNull().defaultNow(),
    updatedBy: (0, pg_core_1.uuid)()
        .notNull()
        .references(() => schema_1.user.id),
}, (t) => [
    (0, pg_core_1.uniqueIndex)("uq_source_system_code")
        .on(t.tenantId, t.sourceSystemCode)
        .where((0, drizzle_orm_1.sql) `superseded_at IS NULL`),
    // ONE LIVE PLATFORM PER MIRROR `data_source`, which is what makes one building resolve to one
    // platform (`J-467`, `D-877`). A `carease.facilities` row carries ONE `data_source`, and the
    // platform is looked up by that value — so two live rows sharing it make the lookup ambiguous
    // for every building on that platform at once. The service now treats that as an internal
    // invariant failure rather than asking the nurse which one she read the value from, and this
    // index is what stops the state arising: a second live row is refused at write time.
    // Partial on `superseded_at IS NULL` like the code index above, because supersession is how a
    // platform is retired and a retired row must not block its replacement.
    // One live row per data source ACROSS ALL TENANTS: a data source is one customer's, named by the
    // platform operator when provisioning it (J-694, `03-RPM-SCHEMA.md` §4.2.1). It was per tenant (D-877).
    (0, pg_core_1.uniqueIndex)("uq_source_system_mirror_value")
        .on(t.mirrorDataSourceValue)
        .where((0, drizzle_orm_1.sql) `superseded_at IS NULL AND mirror_data_source_value IS NOT NULL`),
    // Every effective-dated table in this schema refuses a period that ends at or before it
    // starts; ten of the fourteen said so and these four did not (D-286, J-139).
    (0, pg_core_1.check)("ss_period", (0, drizzle_orm_1.sql) `${t.validTo} IS NULL OR ${t.validTo} > ${t.validFrom}`),
]);
exports.vitalSignDefinitions = (0, pg_core_1.pgTable)("vital_sign_definitions", {
    vitalSignDefinitionId: (0, pg_core_1.uuid)().primaryKey().defaultRandom(),
    tenantId: (0, pg_core_1.uuid)()
        .notNull()
        .references(() => foundation_1.tenants.tenantId),
    vitalCode: e.vitalCode().notNull(),
    displayLabel: (0, pg_core_1.text)().notNull(),
    loincCode: (0, pg_core_1.text)().notNull(),
    loincCodeSecondary: (0, pg_core_1.text)(),
    // text, not an enum, and §8.1's Zod enum over the five codes is not a contradiction: UCUM is an
    // external code system this schema does not own and cannot close, so the DATABASE stores a UCUM
    // code and the APPLICATION narrows it to the five this protocol compares in. drizzle-zod
    // projects text() to z.string(); the narrowing is declared beside the route, not inferred from
    // the column, which is where a closed set that is ours rather than UCUM's belongs (S4-2-D39).
    ucumUnit: (0, pg_core_1.text)().notNull(), // comparison unit (bands)
    ucumExportUnit: (0, pg_core_1.text)().notNull(), // FHIR canonical unit
    plausibleMin: (0, pg_core_1.numeric)({ precision: 8, scale: 2 }).notNull(), // NOT NULL — CR-20
    plausibleMax: (0, pg_core_1.numeric)({ precision: 8, scale: 2 }).notNull(),
    isClassified: (0, pg_core_1.boolean)().notNull().default(true),
    detectionPrecedence: (0, pg_core_1.integer)().notNull(), // SpO2 before HR — CR-5
    detectionWordPatterns: (0, pg_core_1.text)().array().notNull(),
    detectionShapePatterns: (0, pg_core_1.text)()
        .array()
        .notNull()
        .default((0, drizzle_orm_1.sql) `'{}'`),
    labelNoisePattern: (0, pg_core_1.text)(), // CR-6
    readingGroupKind: e.readingGroupKind(),
    fhirComponentRole: e.fhirComponentRole(),
    validFrom: (0, pg_core_1.date)().notNull(),
    validTo: (0, pg_core_1.date)(),
    recordedAt: (0, pg_core_1.timestamp)({ withTimezone: true }).notNull().defaultNow(),
    supersededAt: (0, pg_core_1.timestamp)({ withTimezone: true }),
    createdAt: (0, pg_core_1.timestamp)({ withTimezone: true }).notNull().defaultNow(),
    createdBy: (0, pg_core_1.uuid)()
        .notNull()
        .references(() => schema_1.user.id),
    updatedAt: (0, pg_core_1.timestamp)({ withTimezone: true }).notNull().defaultNow(),
    updatedBy: (0, pg_core_1.uuid)()
        .notNull()
        .references(() => schema_1.user.id),
}, (t) => [
    (0, pg_core_1.uniqueIndex)("uq_vsd_code")
        .on(t.tenantId, t.vitalCode)
        .where((0, drizzle_orm_1.sql) `superseded_at IS NULL`),
    (0, pg_core_1.uniqueIndex)("uq_vsd_precedence")
        .on(t.tenantId, t.detectionPrecedence)
        .where((0, drizzle_orm_1.sql) `superseded_at IS NULL`),
    (0, pg_core_1.check)("vsd_bounds", (0, drizzle_orm_1.sql) `${t.plausibleMin} < ${t.plausibleMax}`),
    // Every effective-dated table in this schema refuses a period that ends at or before it
    // starts; ten of the fourteen said so and these four did not (D-286, J-139).
    (0, pg_core_1.check)("vsd_period", (0, drizzle_orm_1.sql) `${t.validTo} IS NULL OR ${t.validTo} > ${t.validFrom}`),
]);
exports.classificationBandSets = (0, pg_core_1.pgTable)("classification_band_sets", {
    classificationBandSetId: (0, pg_core_1.uuid)().primaryKey().defaultRandom(),
    tenantId: (0, pg_core_1.uuid)()
        .notNull()
        .references(() => foundation_1.tenants.tenantId),
    bandSetVersion: (0, pg_core_1.integer)().notNull(),
    label: (0, pg_core_1.text)().notNull(),
    sourceDocumentRef: (0, pg_core_1.text)().notNull(),
    supersedesBandSetId: (0, pg_core_1.uuid)(),
    effectiveFrom: (0, pg_core_1.timestamp)({ withTimezone: true }).notNull(),
    effectiveTo: (0, pg_core_1.timestamp)({ withTimezone: true }),
    publishedBy: (0, pg_core_1.uuid)()
        .notNull()
        .references(() => schema_1.user.id),
    publishedAt: (0, pg_core_1.timestamp)({ withTimezone: true }).notNull().defaultNow(),
    createdAt: (0, pg_core_1.timestamp)({ withTimezone: true }).notNull().defaultNow(),
    createdBy: (0, pg_core_1.uuid)()
        .notNull()
        .references(() => schema_1.user.id),
}, (t) => [
    (0, pg_core_1.uniqueIndex)("uq_band_set_version").on(t.tenantId, t.bandSetVersion),
    (0, pg_core_1.index)("ix_band_set_effective").on(t.tenantId, t.effectiveFrom),
    (0, pg_core_1.check)("cbs_period", (0, drizzle_orm_1.sql) `${t.effectiveTo} IS NULL OR ${t.effectiveTo} > ${t.effectiveFrom}`),
]);
exports.classificationBands = (0, pg_core_1.pgTable)("classification_bands", {
    classificationBandId: (0, pg_core_1.uuid)().primaryKey().defaultRandom(),
    tenantId: (0, pg_core_1.uuid)()
        .notNull()
        .references(() => foundation_1.tenants.tenantId),
    classificationBandSetId: (0, pg_core_1.uuid)()
        .notNull()
        .references(() => exports.classificationBandSets.classificationBandSetId),
    vitalCode: e.vitalCode().notNull(),
    oxygenStatus: e.bandOxygenStatus(), // null for every non-SpO2 vital — CR-17
    severityBand: e.severityBand().notNull(),
    direction: e.bandDirection().notNull(),
    comparator: e.bandComparator().notNull(), // every protocol band is strict
    boundaryValue: (0, pg_core_1.numeric)({ precision: 8, scale: 2 }).notNull(),
    unit: (0, pg_core_1.text)().notNull(),
    sourceCellRef: (0, pg_core_1.text)().notNull(), // thresholds.json index — makes SDoD-2 a join
    sourceDefect: (0, pg_core_1.boolean)().notNull().default(false),
    sourceVerbatim: (0, pg_core_1.text)(),
    createdAt: (0, pg_core_1.timestamp)({ withTimezone: true }).notNull().defaultNow(),
    createdBy: (0, pg_core_1.uuid)()
        .notNull()
        .references(() => schema_1.user.id),
}, (t) => [
    // NULLS NOT DISTINCT, and it is the whole constraint: `cb_oxygen_scope` makes oxygen_status
    // NULL for all 16 non-SpO2 cells of §10.1, and a btree unique index treats NULLs as distinct —
    // so without this a published set accepts two HR/CRITICAL/LOW rows with different boundaries
    // and classification stops being deterministic inside a version the document calls immutable.
    // A UNIQUE constraint rather than a unique index, because NULLS NOT DISTINCT is what Drizzle
    // expresses there; the backing index is the same object under the same name.
    (0, pg_core_1.unique)("uq_band_cell")
        .on(t.classificationBandSetId, t.vitalCode, t.oxygenStatus, t.severityBand, t.direction)
        .nullsNotDistinct(),
    (0, pg_core_1.index)("ix_band_lookup").on(t.tenantId, t.classificationBandSetId, t.vitalCode),
    // CLEAR is the absence of a band, never a row
    (0, pg_core_1.check)("cb_no_clear_row", (0, drizzle_orm_1.sql) `${t.severityBand} IN ('CRITICAL','CONCERNING')`),
    // the oxygen dimension applies only where the protocol applies it
    (0, pg_core_1.check)("cb_oxygen_scope", (0, drizzle_orm_1.sql) `(${t.vitalCode} = 'SPO2') = (${t.oxygenStatus} IS NOT NULL)`),
    // the one corrected cell carries what was printed
    (0, pg_core_1.check)("cb_defect_verbatim", (0, drizzle_orm_1.sql) `NOT ${t.sourceDefect} OR ${t.sourceVerbatim} IS NOT NULL`),
]);
exports.rpmFacilityProfiles = (0, pg_core_1.pgTable)("rpm_facility_profiles", {
    rpmFacilityProfileId: (0, pg_core_1.uuid)().primaryKey().defaultRandom(),
    tenantId: (0, pg_core_1.uuid)()
        .notNull()
        .references(() => foundation_1.tenants.tenantId),
    facilityId: (0, pg_core_1.varchar)({ length: 20 }).notNull(), // carease.facilities.id — no FK (N15)
    ianaTimeZone: (0, pg_core_1.text)().notNull(), // CR-11 — validated by trigger
    mirrorTimeZoneObserved: (0, pg_core_1.varchar)({ length: 50 }), // observation, never authority
    mirrorTimeZoneCheckedAt: (0, pg_core_1.timestamp)({ withTimezone: true }),
    mirrorTimeZoneDrift: (0, pg_core_1.boolean)().notNull().default(false),
    isActive: (0, pg_core_1.boolean)().notNull().default(true),
    validFrom: (0, pg_core_1.timestamp)({ withTimezone: true }).notNull().defaultNow(),
    validTo: (0, pg_core_1.timestamp)({ withTimezone: true }),
    recordedAt: (0, pg_core_1.timestamp)({ withTimezone: true }).notNull().defaultNow(),
    supersededAt: (0, pg_core_1.timestamp)({ withTimezone: true }),
    createdAt: (0, pg_core_1.timestamp)({ withTimezone: true }).notNull().defaultNow(),
    createdBy: (0, pg_core_1.uuid)()
        .notNull()
        .references(() => schema_1.user.id),
    updatedAt: (0, pg_core_1.timestamp)({ withTimezone: true }).notNull().defaultNow(),
    updatedBy: (0, pg_core_1.uuid)()
        .notNull()
        .references(() => schema_1.user.id),
}, (t) => [
    (0, pg_core_1.uniqueIndex)("uq_facility_profile_current")
        .on(t.tenantId, t.facilityId)
        .where((0, drizzle_orm_1.sql) `valid_to IS NULL AND superseded_at IS NULL`),
    (0, pg_core_1.index)("ix_facility_profile_asof").on(t.tenantId, t.facilityId, t.validFrom),
    (0, pg_core_1.check)("rfp_period", (0, drizzle_orm_1.sql) `${t.validTo} IS NULL OR ${t.validTo} > ${t.validFrom}`),
]);
/* ------------------------------------------------------------------------------
   Communication routing (CR-43), §4.2.5 and §4.2.10–4.2.14. Current state, not
   bitemporal: every table here is enrolled in the change trail (§7.7(j)), and what an
   alert routed against is its resolution log (§4.3.11), never a replay of these rows.
   Deactivated, never deleted. The routing template (§4.2.6) is not a table.
   ------------------------------------------------------------------------------ */
/* §4.2.5 — one current routing profile per facility. */
exports.rpmFacilityRouting = (0, pg_core_1.pgTable)("rpm_facility_routing", {
    rpmFacilityRoutingId: (0, pg_core_1.uuid)().primaryKey().defaultRandom(),
    tenantId: (0, pg_core_1.uuid)()
        .notNull()
        .references(() => foundation_1.tenants.tenantId),
    facilityId: (0, pg_core_1.varchar)({ length: 20 }).notNull(), // carease.facilities.id — no FK (CR-31)
    routingBehavior: e.routingBehavior(), // null: not set up — resolves UNMET
    textPreferred: (0, pg_core_1.boolean)().notNull().default(false),
    routingHoldReason: (0, pg_core_1.text)(), // set: held for review — resolves UNMET
    routingNotes: (0, pg_core_1.text)(), // shown verbatim, never parsed — CD-4
    dailySummaryTimes: (0, pg_core_1.time)()
        .array()
        .notNull()
        .default((0, drizzle_orm_1.sql) `'{}'`), // local, in the operative zone
    weeklySummaryWeekday: (0, pg_core_1.smallint)(), // 0 Sunday … 6 Saturday
    weeklySummaryTime: (0, pg_core_1.time)(),
    referenceKey: (0, pg_core_1.text)(),
    createdAt: (0, pg_core_1.timestamp)({ withTimezone: true }).notNull().defaultNow(),
    createdBy: (0, pg_core_1.uuid)()
        .notNull()
        .references(() => schema_1.user.id),
    updatedAt: (0, pg_core_1.timestamp)({ withTimezone: true }).notNull().defaultNow(),
    updatedBy: (0, pg_core_1.uuid)()
        .notNull()
        .references(() => schema_1.user.id),
}, (t) => [
    (0, pg_core_1.uniqueIndex)("uq_facility_routing").on(t.tenantId, t.facilityId),
    (0, pg_core_1.uniqueIndex)("uq_facility_routing_reference").on(t.tenantId, t.referenceKey),
    // the weekly summary has a day and a time, or neither: there is no default (OD-14)
    (0, pg_core_1.check)("rfr_weekly_pair", (0, drizzle_orm_1.sql) `(${t.weeklySummaryWeekday} IS NULL) = (${t.weeklySummaryTime} IS NULL)`),
    (0, pg_core_1.check)("rfr_weekday_range", (0, drizzle_orm_1.sql) `
    ${t.weeklySummaryWeekday} IS NULL OR ${t.weeklySummaryWeekday} BETWEEN 0 AND 6`),
]);
/* §4.2.10 — the care units of a mirror facility. Its facility never changes (C13, §7.7(d)). */
exports.rpmCareUnits = (0, pg_core_1.pgTable)("rpm_care_units", {
    careUnitId: (0, pg_core_1.uuid)().primaryKey().defaultRandom(),
    tenantId: (0, pg_core_1.uuid)()
        .notNull()
        .references(() => foundation_1.tenants.tenantId),
    facilityId: (0, pg_core_1.varchar)({ length: 20 }).notNull(), // carease.facilities.id — no FK (CR-31)
    label: (0, pg_core_1.text)().notNull(),
    rooms: (0, pg_core_1.text)(), // shown, never parsed
    mirrorUnitValues: (0, pg_core_1.text)()
        .array()
        .notNull()
        .default((0, drizzle_orm_1.sql) `'{}'`), // exact match pre-selects — CD-1
    isActive: (0, pg_core_1.boolean)().notNull().default(true),
    referenceKey: (0, pg_core_1.text)(),
    createdAt: (0, pg_core_1.timestamp)({ withTimezone: true }).notNull().defaultNow(),
    createdBy: (0, pg_core_1.uuid)()
        .notNull()
        .references(() => schema_1.user.id),
    updatedAt: (0, pg_core_1.timestamp)({ withTimezone: true }).notNull().defaultNow(),
    updatedBy: (0, pg_core_1.uuid)()
        .notNull()
        .references(() => schema_1.user.id),
}, (t) => [
    // one active unit per label per facility, ignoring case; a deactivated label may be reused
    (0, pg_core_1.uniqueIndex)("uq_care_unit_label")
        .on(t.tenantId, t.facilityId, (0, drizzle_orm_1.sql) `lower(${t.label})`)
        .where((0, drizzle_orm_1.sql) `is_active`),
    (0, pg_core_1.uniqueIndex)("uq_care_unit_reference").on(t.tenantId, t.referenceKey),
    // ix_care_unit_facility is declared once, in §7.8 (Q9)
]);
/* §4.2.11 — a labelled recipient, facility-wide or of one care unit. */
exports.rpmRoutingContacts = (0, pg_core_1.pgTable)("rpm_routing_contacts", {
    routingContactId: (0, pg_core_1.uuid)().primaryKey().defaultRandom(),
    tenantId: (0, pg_core_1.uuid)()
        .notNull()
        .references(() => foundation_1.tenants.tenantId),
    facilityId: (0, pg_core_1.varchar)({ length: 20 }).notNull(), // carease.facilities.id — no FK (CR-31)
    scope: e.routingContactScope().notNull(),
    careUnitId: (0, pg_core_1.uuid)().references(() => exports.rpmCareUnits.careUnitId),
    label: (0, pg_core_1.text)(), // kept as written; may be blank
    isActive: (0, pg_core_1.boolean)().notNull().default(true),
    referenceKey: (0, pg_core_1.text)(),
    createdAt: (0, pg_core_1.timestamp)({ withTimezone: true }).notNull().defaultNow(),
    createdBy: (0, pg_core_1.uuid)()
        .notNull()
        .references(() => schema_1.user.id),
    updatedAt: (0, pg_core_1.timestamp)({ withTimezone: true }).notNull().defaultNow(),
    updatedBy: (0, pg_core_1.uuid)()
        .notNull()
        .references(() => schema_1.user.id),
}, (t) => [
    (0, pg_core_1.uniqueIndex)("uq_routing_contact_reference").on(t.tenantId, t.referenceKey),
    // C13, the half a CHECK can see; that the unit is one of the contact's facility's is §7.7(d)
    (0, pg_core_1.check)("rrc_scope_shape", (0, drizzle_orm_1.sql) `(${t.scope} = 'UNIT') = (${t.careUnitId} IS NOT NULL)`),
    // ix_routing_contact_scope is declared once, in §7.8 (Q9)
]);
/* §4.2.12 — one address or number of a contact. Staff contact values are configuration, not PHI,
   and never appear in a path, a query string or a log line. */
exports.rpmRoutingEndpoints = (0, pg_core_1.pgTable)("rpm_routing_endpoints", {
    routingEndpointId: (0, pg_core_1.uuid)().primaryKey().defaultRandom(),
    tenantId: (0, pg_core_1.uuid)()
        .notNull()
        .references(() => foundation_1.tenants.tenantId),
    routingContactId: (0, pg_core_1.uuid)()
        .notNull()
        .references(() => exports.rpmRoutingContacts.routingContactId),
    channel: e.endpointChannel().notNull(),
    value: (0, pg_core_1.text)().notNull(),
    phoneKind: e.phoneKind(),
    isCallable: (0, pg_core_1.boolean)(), // stored, never inferred from a number
    isSummaryOnly: (0, pg_core_1.boolean)().notNull().default(false),
    extension: (0, pg_core_1.text)(),
    reachWindow: e.reachWindow().notNull().default("ALL_TIMES"),
    reachDays: e.reachDays(),
    reachStartHour: (0, pg_core_1.smallint)(), // local; an end below the start wraps midnight
    reachEndHour: (0, pg_core_1.smallint)(),
    isActive: (0, pg_core_1.boolean)().notNull().default(true),
    referenceKey: (0, pg_core_1.text)(),
    createdAt: (0, pg_core_1.timestamp)({ withTimezone: true }).notNull().defaultNow(),
    createdBy: (0, pg_core_1.uuid)()
        .notNull()
        .references(() => schema_1.user.id),
    updatedAt: (0, pg_core_1.timestamp)({ withTimezone: true }).notNull().defaultNow(),
    updatedBy: (0, pg_core_1.uuid)()
        .notNull()
        .references(() => schema_1.user.id),
}, (t) => [
    (0, pg_core_1.uniqueIndex)("uq_routing_endpoint_reference").on(t.tenantId, t.referenceKey),
    // C24 — the endpoint shape. An email carries no phone attribute and no hours; a phone says what
    // kind it is and whether it may be called; only an email may be summary-only.
    (0, pg_core_1.check)("rre_email_shape", (0, drizzle_orm_1.sql) `
    ${t.channel} <> 'EMAIL' OR (${t.phoneKind} IS NULL AND ${t.isCallable} IS NULL
      AND ${t.extension} IS NULL AND ${t.reachStartHour} IS NULL AND ${t.reachEndHour} IS NULL)`),
    (0, pg_core_1.check)("rre_phone_shape", (0, drizzle_orm_1.sql) `
    ${t.channel} <> 'PHONE' OR (${t.phoneKind} IS NOT NULL AND ${t.isCallable} IS NOT NULL)`),
    (0, pg_core_1.check)("rre_summary_only_email", (0, drizzle_orm_1.sql) `NOT ${t.isSummaryOnly} OR ${t.channel} = 'EMAIL'`),
    (0, pg_core_1.check)("rre_hours", (0, drizzle_orm_1.sql) `
    (${t.reachStartHour} IS NULL) = (${t.reachEndHour} IS NULL)
    AND (${t.reachStartHour} IS NULL OR ${t.reachStartHour} BETWEEN 0 AND 24)
    AND (${t.reachEndHour}   IS NULL OR ${t.reachEndHour}   BETWEEN 0 AND 24)`),
    // ix_routing_endpoint_contact is declared once, in §7.8 (Q9)
]);
/* §4.2.13 — the tenant's standing copies, by scope. A copy never discharges a step. */
exports.rpmStandingCcs = (0, pg_core_1.pgTable)("rpm_standing_ccs", {
    standingCcId: (0, pg_core_1.uuid)().primaryKey().defaultRandom(),
    tenantId: (0, pg_core_1.uuid)()
        .notNull()
        .references(() => foundation_1.tenants.tenantId),
    scope: e.standingCcScope().notNull(),
    address: (0, pg_core_1.text)().notNull(),
    label: (0, pg_core_1.text)().notNull(),
    isActive: (0, pg_core_1.boolean)().notNull().default(true),
    referenceKey: (0, pg_core_1.text)(),
    createdAt: (0, pg_core_1.timestamp)({ withTimezone: true }).notNull().defaultNow(),
    createdBy: (0, pg_core_1.uuid)()
        .notNull()
        .references(() => schema_1.user.id),
    updatedAt: (0, pg_core_1.timestamp)({ withTimezone: true }).notNull().defaultNow(),
    updatedBy: (0, pg_core_1.uuid)()
        .notNull()
        .references(() => schema_1.user.id),
}, (t) => [
    (0, pg_core_1.uniqueIndex)("uq_standing_cc_address")
        .on(t.tenantId, t.scope, (0, drizzle_orm_1.sql) `lower(${t.address})`)
        .where((0, drizzle_orm_1.sql) `is_active`),
    (0, pg_core_1.uniqueIndex)("uq_standing_cc_reference").on(t.tenantId, t.referenceKey),
]);
/* §4.2.14 — the lines a message must contain. A null facility is every facility's default line;
   a facility's own lines follow the defaults. */
exports.rpmNotificationAttributes = (0, pg_core_1.pgTable)("rpm_notification_attributes", {
    notificationAttributeId: (0, pg_core_1.uuid)().primaryKey().defaultRandom(),
    tenantId: (0, pg_core_1.uuid)()
        .notNull()
        .references(() => foundation_1.tenants.tenantId),
    facilityId: (0, pg_core_1.varchar)({ length: 20 }), // null: the default line — no FK (CR-31)
    notificationType: e.notificationType().notNull(),
    attributeText: (0, pg_core_1.text)().notNull(),
    ordinal: (0, pg_core_1.smallint)().notNull(),
    isActive: (0, pg_core_1.boolean)().notNull().default(true),
    referenceKey: (0, pg_core_1.text)(),
    createdAt: (0, pg_core_1.timestamp)({ withTimezone: true }).notNull().defaultNow(),
    createdBy: (0, pg_core_1.uuid)()
        .notNull()
        .references(() => schema_1.user.id),
    updatedAt: (0, pg_core_1.timestamp)({ withTimezone: true }).notNull().defaultNow(),
    updatedBy: (0, pg_core_1.uuid)()
        .notNull()
        .references(() => schema_1.user.id),
}, (t) => [
    // the coalesce, for uq_cfg's reason: a default line (facility_id NULL) must collide with another
    // default line of the same type and ordinal, which a plain unique index would let through
    (0, pg_core_1.uniqueIndex)("uq_notification_attribute_ordinal")
        .on(t.tenantId, (0, drizzle_orm_1.sql) `coalesce(${t.facilityId}, '')`, t.notificationType, t.ordinal)
        .where((0, drizzle_orm_1.sql) `is_active`),
    (0, pg_core_1.uniqueIndex)("uq_notification_attribute_reference").on(t.tenantId, t.referenceKey),
]);
// §4.2.9 / §7.7(f). A view, not a table. It returns p.tenant_id as its first column and filters on
// nothing: it is the application that scopes every read to the caller's tenant, here as everywhere
// else. A caller that forgets the predicate sees other tenants' facilities, and that is a defect in
// the query, not in the view. Five check columns, and only has_active_care_unit refuses anything
// (CR-43); a facility with no routing row reads false, not null, on the two routing checks.
exports.vFacilityReadiness = (0, pg_core_1.pgView)("v_facility_readiness", {
    tenantId: (0, pg_core_1.uuid)("tenant_id").notNull(),
    facilityId: (0, pg_core_1.varchar)("facility_id", { length: 20 }).notNull(),
    rpmFacilityProfileId: (0, pg_core_1.uuid)("rpm_facility_profile_id").notNull(),
    hasProfile: (0, pg_core_1.boolean)("has_profile").notNull(),
    hasRouting: (0, pg_core_1.boolean)("has_routing").notNull(),
    hasActiveCareUnit: (0, pg_core_1.boolean)("has_active_care_unit").notNull(),
    hasCriticalDestination: (0, pg_core_1.boolean)("has_critical_destination").notNull(),
    hasSummarySchedule: (0, pg_core_1.boolean)("has_summary_schedule").notNull(),
}).as((0, drizzle_orm_1.sql) `SELECT p.tenant_id, p.facility_id, p.rpm_facility_profile_id,
       true                                                        AS has_profile,
       (r.routing_behavior IS NOT NULL AND r.routing_hold_reason IS NULL)
                                                                   AS has_routing,
       EXISTS (SELECT 1 FROM rpm_care_units u
                WHERE u.tenant_id = p.tenant_id AND u.facility_id = p.facility_id
                  AND u.is_active)                                 AS has_active_care_unit,
       -- any scope, any time of day: a callable phone or an alert email among the active contacts
       EXISTS (SELECT 1 FROM rpm_routing_contacts c
                 JOIN rpm_routing_endpoints e ON e.routing_contact_id = c.routing_contact_id
                WHERE c.tenant_id = p.tenant_id AND c.facility_id = p.facility_id
                  AND c.is_active AND e.is_active
                  AND ((e.channel = 'PHONE' AND e.is_callable)
                    OR (e.channel = 'EMAIL' AND NOT e.is_summary_only)))
                                                                   AS has_critical_destination,
       -- daily times where the behaviour sends Concerning alerts to the summary; the weekly day and
       -- time always. A facility with no routing row has neither, so the check is false, not null.
       (r.weekly_summary_weekday IS NOT NULL
        AND (r.routing_behavior IS NULL
             OR r.routing_behavior NOT IN ('SUMMARY_ONLY','CONDITIONAL_CRIT')
             OR cardinality(r.daily_summary_times) > 0))           AS has_summary_schedule
  FROM rpm_facility_profiles p
  LEFT JOIN rpm_facility_routing r
         ON r.tenant_id = p.tenant_id AND r.facility_id = p.facility_id
 WHERE p.valid_to IS NULL AND p.superseded_at IS NULL AND p.is_active`);
//# sourceMappingURL=rpm-config.js.map